/**
 * Iris dark map style. Uses Carto's free dark-matter raster tiles as a
 * baseline (low-key, no labels visible at low zoom) and applies the Iris
 * palette via the JSON style spec. We add asset/dependency/vessel layers
 * dynamically after the map loads.
 */
import type { StyleSpecification } from 'maplibre-gl';

export const irisDarkStyle: StyleSpecification = {
  version: 8,
  glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf',
  sources: {
    'iris-base': {
      type: 'raster',
      tiles: [
        'https://basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png',
        'https://b.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png',
        'https://c.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png',
      ],
      tileSize: 256,
      attribution:
        '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> · © <a href="https://carto.com/attributions">CARTO</a>',
    },
    'iris-labels': {
      type: 'raster',
      tiles: [
        'https://basemaps.cartocdn.com/rastertiles/dark_only_labels/{z}/{x}/{y}.png',
        'https://b.basemaps.cartocdn.com/rastertiles/dark_only_labels/{z}/{x}/{y}.png',
        'https://c.basemaps.cartocdn.com/rastertiles/dark_only_labels/{z}/{x}/{y}.png',
      ],
      tileSize: 256,
    },
  },
  layers: [
    {
      id: 'iris-bg',
      type: 'background',
      paint: { 'background-color': '#0e1316' },
    },
    {
      id: 'iris-base',
      type: 'raster',
      source: 'iris-base',
      paint: { 'raster-opacity': 1.0 },
    },
    {
      id: 'iris-labels',
      type: 'raster',
      source: 'iris-labels',
      paint: { 'raster-opacity': 0.55 },
    },
  ],
};
